import { Pagination } from '@components/Pagination'
import { PenNameStoryList } from '@features/profile/components/PenNameStoryList'
import { TabBody } from '@components/Tabs/components/TabBody'
import { PenNameSearchSelect } from '@features/profile/components/PenNameSearchSelect'
import { Loading } from '@components/Loading'
import { NoBookIcon } from '@components/icons/NoBookIcon'
import { PenNameTabProps } from './interface'

export function PenNameTab({
  userId,
  penNameList,
  page,
  perpage,
  total,
  canFollow,
  handlePaginationChange,
  handleSearchChange,
  handleFollowPenName,
  handleLikeBook,
  isLoading,
  isLoadingToggleBookLike,
}: PenNameTabProps) {
  return (
    <TabBody tabId='penName'>
      <div className='flex flex-col space-y-[20px] border-t border-gray-3 dark:border-purple'>
        <div className='flex mobile:flex-col mobile:space-y-[20px] justify-between items-center mt-[20px]'>
          <div className='w-[300px] mobile:w-full'>
            <PenNameSearchSelect
              userId={userId}
              onSearch={handleSearchChange}
            />
          </div>
        </div>
        {isLoading ? (
          <div className='flex justify-center'>
            <Loading />
          </div>
        ) : (
          <>
            {penNameList.length > 0 ? (
              <>
                <div
                  data-test='pen-name-list'
                  className='flex flex-col space-y-[20px]'
                >
                  {penNameList.map(item => (
                    <PenNameStoryList
                      key={item.id}
                      books={item.books}
                      penName={item.firstPenName}
                      facebookLink={item.facebookLink}
                      twitterLink={item.twitterLink}
                      totalWriting={item.books.length}
                      totalBookmark={item.totalBookshelf}
                      totalReading={item.totalRead}
                      follower={item.totalFollower}
                      isFollowed={item.isFollowed}
                      canFollow={canFollow}
                      isLoadingToggleBookLike={isLoadingToggleBookLike}
                      onFollow={() => handleFollowPenName(item.id)}
                      onLikeBook={bookId => handleLikeBook(item.id, bookId)}
                    />
                  ))}
                </div>
                <Pagination
                  page={page}
                  perpage={perpage}
                  total={total}
                  pageChange={handlePaginationChange}
                />
              </>
            ) : (
              <div className='flex flex-col items-center justify-center pt-[40px]'>
                <NoBookIcon className='w-[120px] h-[119px] mb-[10px]' />
                <span className='font-mitr font-medium text-[18px] text-secondary-1 dark:text-dark-10 mb-[31px]'>
                  ไม่พบนามปากกา
                </span>
              </div>
            )}
          </>
        )}
      </div>
    </TabBody>
  )
}
